import { mapGetters } from 'vuex'
import {
  ANOMALIES_DETAILS_REQ,
  ANOMALIES_LIST_REQ,
  ANOMALIES_LIST_SUCCESS
} from '@/store/modules/anomalies/anomalies.type'

export default {
  data () {
    return {
      detectionType: 'login',
      chartOptions: {
        layout: {
          padding: {
            left: 25
          }
        },
        title: {
          display: true,
          text: 'Login Anomalies'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [
            {
              offset: true,
              type: 'time'
            }
          ]
        },
        legend: {
          display: false
        },
        subtitle: 'Count'
      }
    }
  },
  methods: {
    refreshAnomalies () {
      Promise.all([
        this.$store.dispatch(ANOMALIES_LIST_REQ, { dateRangeSel: this.anomaliesDateRangeUserSetting })
      ]).then(collection => {
        this.$store.dispatch(ANOMALIES_LIST_SUCCESS)
      })
    },
    loadAnomalyDetails () {
      this.loadingAnomalyDetails = true
      this.$store.dispatch(ANOMALIES_DETAILS_REQ, { uid: this.details.uid, type: this.detectionType }).then(
        anomalyDetails => {
          this.details.anomalyDetails = anomalyDetails
          this.loadingAnomalyDetails = false
        },
        errMsg => {}
      )
    },

    /**
     * - Investigate
     * Failed login w/Host
     * Failed login w/Dest IP
     */
    gotoThreatHunting (details, type) {
      let threatHuntingEntitiesMap = {
        ip: 'destAddr',
        city: 'destAddrCity',
        country: 'destAddrCountry',
        agentId: 'agentId',
        // program: 'sourceComm',
        program: 'sourceBinaryName',
        processId: 'targetPid'
      }
      // return threat_hunting_params
      let threatHuntParam = `date_range:${this.anomaliesDateRangeUserSetting}`
      let agentId = details.agentId
      // use long form of agent-id for threat hunting hostname conversion
      if (details.host && details.host.agentId) {
        agentId = details.host.agentId
      }
      if (type === 'user') {
        threatHuntParam = `${threatHuntParam}+edgeName:in:user`
      } else {
        threatHuntParam = `${threatHuntParam}+edgeName:in:user:exec:file:network:system`
      }

      if (_.isEmpty(details.ip) && agentId) {
        threatHuntParam = `${threatHuntParam}+${threatHuntingEntitiesMap['agentId']}:eq:${agentId}`
      } else if (!_.isEmpty(details.ip) && agentId) {
        threatHuntParam = `${threatHuntParam}+${threatHuntingEntitiesMap['destAddr']}:in:${details.ip}+${threatHuntingEntitiesMap['agentId']}:eq:${agentId}`
      }
      if (!_.isEmpty(details.program)) {
        threatHuntParam = `${threatHuntParam}+${threatHuntingEntitiesMap['program']}:eq:${details.program}`
      }
      // if "user" in entities and os == "Windows":
      //     threat_hunting_params["sourceWinTargetUser"] = entities["user"]

      if (!_.isEmpty(details.user) && details.host && details.host.system.os.toLowerCase() === 'windows') {
        threatHuntParam = `${threatHuntParam}+sourceWinTargetUser:eq:${details.user}`
      }

      // field not supported in threat hunting query
      // if (!_.isEmpty(details.processId)) {
      //   threatHuntParam = `${threatHuntParam}+${threatHuntingEntitiesMap['processId']}:eq:${details.processId}`
      // }
      this.$router.push({
        name: 'threat-hunting',
        query: { search: threatHuntParam }
      })
    }
  },
  computed: {
    ...mapGetters(['anomaliesDateRangeUserSetting']),
    anomalyDetails () {
      if (this.details.anomalyDetails) {
        return this.details.anomalyDetails
      }
      return this.details
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/expand/expandedAnomalyDetectionMixin.js